"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const auth_1 = require("../auth");
const OsmosysResource_1 = require("./OsmosysResource");
let OsmosysResourceInstance = class OsmosysResourceInstance extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => OsmosysResource_1.OsmosysResource),
    typeorm_1.ManyToOne(() => OsmosysResource_1.OsmosysResource, resource => resource.instances),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], OsmosysResourceInstance.prototype, "masterResource", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => OsmosysResource_1.OsmosysResource),
    typeorm_1.OneToOne(() => OsmosysResource_1.OsmosysResource, resource => resource.instance),
    tslib_1.__metadata("design:type", Object)
], OsmosysResourceInstance.prototype, "instanceResource", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysResourceInstance.prototype, "creatingUser", void 0);
OsmosysResourceInstance = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], OsmosysResourceInstance);
exports.OsmosysResourceInstance = OsmosysResourceInstance;
//# sourceMappingURL=OsmosysResourceInstance.js.map